// GrowthLoopFooterCTA.jsx
import Configs from '../Configs';

import { useTranslation } from 'react-i18next';

// ------------------------------------------------------------------------------------------------
// Component
// ------------------------------------------------------------------------------------------------
export default function GrowthLoopFooterCTA() {
  const { t } = useTranslation(['trust-center']);

  return (
    <footer className="border-t border-gray-100 mt-8 pt-6 pb-8 text-xs text-gray-400 bg-white/60">
      <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-3">
        <div className="text-center md:text-left">
          {t('trust-center.growth-loop-footer.cta')} {' '}
          <a
            href="https://kincode.ai/contact"
            target="_blank"
            rel="noreferrer"
            className="text-teal-700 hover:text-teal-900 underline font-medium"
          >
            {t('trust-center.growth-loop-footer.cta-link')}
          </a>
          .
        </div>
        <div className="flex items-center gap-2 text-center md:text-right">
          <span className="text-gray-500">{t('trust-center.growth-loop-footer.powered-by')}</span>
          <img
            src={Configs.companyLogoSmall}
            alt={t('trust-center.growth-loop-footer.brand')}
            className="h-5 w-auto"
            loading="lazy"
          />
        </div>
      </div>
    </footer>
  );
}